import React, { useEffect, useState } from "react";
import "../styles/uiCss/AnimatedTesti.css";
import useIsMobile from "../components/isMobile/IsMobile";

const AnimatedTestimonials = ({ testimonials, autoplay = false }) => {
  const [active, setActive] = useState(0);

  const handleNext = () => {
    setActive((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    if (autoplay) {
      const interval = setInterval(handleNext, 5000);
      return () => clearInterval(interval);
    }
  }, [autoplay]);

    const isMobile = useIsMobile(768);


  return (
    <div className="testimonial-container" style={{marginBottom: isMobile ? 0 : -100}}>
      <div className="testimonial-content">
        <div className="testimonial-image-container">
          {testimonials.map((t, index) => (
            <img
              key={index}
              src={t.src}
              alt={t.name}
              className={`testimonial-image ${
                index === active ? "active" : "inactive"
              }`}
            />
          ))}
        </div>

        <div className="testimonial-text" style={{marginTop: isMobile ? -50 : 0}}>
          <h3>{testimonials[active].name}</h3>
          <p className="designation">{testimonials[active].designation}</p>
          <p className="quote" style={{fontSize:isMobile ? 16 : 18}}>{testimonials[active].quote}</p>

          <div className="testimonial-buttons">
            <button onClick={handlePrev}>‹</button>
            <button onClick={handleNext}>›</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedTestimonials;
